import { Component, inject, OnDestroy, OnInit, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConsentStoreRepository } from '../shared/repositories/consent.repository';
import { SessionStoreRepository } from '../shared/repositories/session.repository';
import { SchemaRepository } from '../shared/repositories/schema.repository';
import { LoadingSpinnerGrowComponent } from '../shared/components/loading/loading-spinner-grow/loading-spinner-grow.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { HasFogPService } from '../shared/store/hasFogpStore';
import { environment } from '../../environments/environment';

@Component({
    selector: 'authenticated',
    imports: [LoadingSpinnerGrowComponent, TranslocoDirective],
    templateUrl: './authenticated.component.html',
    styleUrl: './authenticated.component.scss'
})
export class AuthenticatedComponent implements OnInit, OnDestroy {
    private readonly router = inject(Router);
    private readonly sessionRepository = inject(SessionStoreRepository);
    private readonly consentRepository = inject(ConsentStoreRepository);
    private readonly schemaService = inject(SchemaRepository);
    private readonly hasFogpService = inject(HasFogPService)

    private subsciption: Subscription = new Subscription();
    private isPatient: boolean = this.sessionRepository.isPatient;
    private archiveCpr = (history.state as { archiveCpr?: string })?.archiveCpr;
    loginIsError: boolean = false;

    patientHasConsent: boolean | null = this.consentRepository.hasConsent;

    ngOnInit(): void {
        if (this.isPatient) {
            this.handlePatientHasConsent();
        } else {
            this.handleNavigation(null);
        }
    }

    ngOnDestroy(): void {
        if (this.subsciption) return this.subsciption.unsubscribe();
    }

    private handlePatientHasConsent() {
        if (this.consentRepository.hasConsent === null) {
            this.subsciption.add(
                this.consentRepository.loadHasConsent$().subscribe({
                    next: (hasConsent: boolean) => {
                        this.handleNavigation(hasConsent);
                    }
                })
            );
        } else {
            this.handleNavigation(this.patientHasConsent);
        }
    }

    private handleNavigation(hasConsent: boolean | null) {
        if (this.isPatient && !hasConsent) {
            this.router.navigate(['/data-processing-info']);
            return;
        }

        if (environment.checkFogpForms && this.isPatient && !this.hasFogpService.getHasForms()) {
            this.schemaService.getHasFogPForms$().subscribe(result => {
                this.router.navigate([result ? '/reception' : '/schemas']);
            });
            return;
        }

        this.router.navigate(['/schemas'], this.archiveCpr ? { state: { archiveCpr: this.archiveCpr } } : {});
    }

}
